// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d1_QF","tabsBox":"styles_tabsBox__1yxqv","createButton":"styles_createButton__1_zCC"};